export const VegaIconBreakpoint = 24
